import type { GridColDef } from '@mui/x-data-grid';
import type { GetMeasurementsStatsResponse } from '@weft/api-definition';
import type { ItemOf } from '@weft/utils';
import { dayjs } from '@weft/utils';
import React from 'react';
import type { FieldPath } from 'react-hook-form';
import type { VyTableMinimalProps } from '../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../components/new-design/table/vy-table/VyTable';

export const DataMetringMeasurementsTable: React.FC<VyTableMinimalProps<ItemOf<GetMeasurementsStatsResponse['measurementsStats']>>> = ({
  itemsCount,
  items,
  loadingItems = false,
  ...props
}) => {
  return (
    <VyTable
      itemsCount={itemsCount}
      items={items}
      columns={DATA_METERING_MEASUREMENTS_COLUMNS}
      loadingItems={loadingItems}
      {...props}
    />
  );
};

export const DATA_METERING_MEASUREMENTS_KEYS = Object.freeze({
  day: 'day',
  customerId: 'customerExternalId',
  customer: 'customer',
  product: 'product',
  subProduct: 'productVariant',
  quantity: 'quantity',
  price: 'price',
} satisfies Record<string, FieldPath<ItemOf<GetMeasurementsStatsResponse['measurementsStats']>>>);

export const DATA_METERING_MEASUREMENTS_COLUMNS: GridColDef<ItemOf<GetMeasurementsStatsResponse['measurementsStats']>>[] = [
  {
    field: DATA_METERING_MEASUREMENTS_KEYS.day,
    headerName: 'Day',
    flex: 1,
    renderCell: ({ value }) => dayjs(value).format('DD MMM YYYY'),
  },
  {
    field: DATA_METERING_MEASUREMENTS_KEYS.customerId,
    headerName: 'Customer ID',
    flex: 1,
  },
  {
    field: DATA_METERING_MEASUREMENTS_KEYS.customer,
    headerName: 'Customer',
    flex: 1,
  },
  {
    field: DATA_METERING_MEASUREMENTS_KEYS.product,
    headerName: 'Product',
    flex: 1,
  },
  {
    field: DATA_METERING_MEASUREMENTS_KEYS.subProduct,
    headerName: 'Sub Product',
    flex: 1,
  },
  {
    field: DATA_METERING_MEASUREMENTS_KEYS.quantity,
    headerName: 'Quantity',
    flex: 1,
  },
  {
    field: DATA_METERING_MEASUREMENTS_KEYS.price,
    headerName: 'Price',
    flex: 1,
  },
];